import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { HomeFeatures } from '../components/home/HomeFeatures';
import { HomeWorkflow } from '../components/home/HomeWorkflow';
import { HomePersonas } from '../components/home/HomePersonas';
import { HomeFooterParallax } from '../components/home/HomeFooterParallax';

/**
 * Marketing homepage — shown to unauthenticated visitors at "/".
 * Authenticated users hit /dashboard via the routing fork in App.tsx.
 *
 * The .font-inter class scopes the Inter import to this page so the rest
 * of the app keeps its existing Google-Docs-style font.
 */
export function HomePage() {
  return (
    <div className="font-inter bg-[#f8f9fa] min-h-screen text-gray-900">
      <HomeHero />
      <HomeFeatures />
      <HomeWorkflow />
      <HomePersonas />
      <HomeFooterParallax />
    </div>
  );
}

export default HomePage;
